/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_BookingInputs */

const en_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Bookings`)
};

const de_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder-Buchungen`)
};

const es_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas de miembros`)
};

const fr_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservations membres`)
};

const it_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenotazioni membri`)
};

const pt_br2_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas de membros`)
};

const pl_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje członków`)
};

const hu_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag foglalások`)
};

const ro_admin_dashboard_invoice_tags_booking = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervari Membri`)
};

/**
* | output |
* | --- |
* | "Member Bookings" |
*
* @param {Admin_Dashboard_Invoice_Tags_BookingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_booking = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_BookingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_BookingInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_booking(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_booking(inputs)
	return ro_admin_dashboard_invoice_tags_booking(inputs)
});
export { admin_dashboard_invoice_tags_booking as "admin.dashboard.invoice_tags.booking" }